module.exports = __webpack_public_path__ + "img/jg.60443420.png";